import React, { useEffect } from "react";
import "./App.css";
import AppRoutes from "./routes";
import { Container } from "@mui/material";
import { connectWebSocket } from "./services/web-socket";
import { useDispatch } from "react-redux";
function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    connectWebSocket(dispatch);
  }, [dispatch]);

  return (
    <Container
      // maxWidth="xs"
      sx={{
        p: 0,
        m: 0,
        width: "100%",
        maxWidth: "1080px",
        margin: "0 auto",
      }}
    >
      <AppRoutes />
    </Container>
  );
}

export default App;
